// Backend client-storage flag: the extension prompt is shown at most once per user.
export const RECORDING_EXTENSION_PROMPT_STORAGE_KEY = 'recordingExtensionPromptShown';

// Chrome Web Store id of the Rask Screen Recorder extension.
export const RASK_SCREEN_RECORDER_EXTENSION_ID = 'jcldnbjjmpmhilaahbcpdmenginnjond';

export const RASK_SCREEN_RECORDER_CHROME_STORE_URL = `https://chromewebstore.google.com/detail/rask-screen-recorder/${RASK_SCREEN_RECORDER_EXTENSION_ID}`;
